import { TModalContent } from 'shared/types/features';
import { TApplicationState } from 'shared/types/redux';

export const selectModalContent = (state: TApplicationState): TModalContent => {
  return state.modal.content;
};
